var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{staticStyle:{"height":"100%"},attrs:{"default-active":_vm.activeMenu}},_vm._l((_vm.authRoutes),function(menu){return _c('SubMenu',{key:menu.path,attrs:{"menu":menu}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }